import { Amplify } from 'aws-amplify';

const configureAmplify = () => {
  const oauthDomain = (process.env.REACT_APP_COGNITO_OAUTH_DOMAIN ?? '').replace(/^https?:\/\//, '');
  const siteUrl = process.env.REACT_APP_SITE_URL ?? '';
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const redirectCandidates = [currentOrigin, siteUrl, 'http://localhost:3000'].filter(Boolean);
  const redirectSignIn = Array.from(new Set(redirectCandidates));
  const redirectSignOut = Array.from(new Set(redirectCandidates));

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_USER_POOL_ID as string,
        userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID as string,
        loginWith: {
          email: true,
          oauth: {
            domain: oauthDomain,
            redirectSignIn,
            redirectSignOut,
            responseType: 'code',
            scopes: ['openid', 'email', 'profile'],
            providers: ['Google'],
          },
        },
      },
    },
  });
};

export default configureAmplify;
